class NotificationHub extends HTMLElement {
  constructor() {
    super();

    this.notificationLinks = document.querySelectorAll('.js-open-notification-hub');
    this.notificationContainer = document.querySelector('.js-header-notification');
    this.notificationClose = document.querySelectorAll('.js-notification-background-close, .js-close-notification');
    this.notificationBackground = document.querySelector('.js-notification-background-close');

    this.notificationLinks.forEach(link => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleNotificationContainerClass(true);
      });
    });

    this.notificationClose.forEach(btn => {
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        this.toggleNotificationContainerClass(false);
      });
    });

    if (this.notificationContainer) {
      this.notificationContainer.addEventListener('click', (e) => {

        const openTrigger = e.target.closest('.js-open-inner-content');
        if (openTrigger) {
          e.preventDefault();
          const item = openTrigger.closest('.notification-item');
          if (!item) return;
          const panel = item.querySelector('.js-notification-inner-content');
          if (!panel) return;

          this.closeAllInner();

          panel.classList.add('active');
          item.classList.add('inner-active');
          openTrigger.setAttribute('aria-expanded', 'true');
        }

        const closeTrigger = e.target.closest('.js-close-inner-content');
        if (closeTrigger) {
          e.preventDefault();
          const item = closeTrigger.closest('.notification-item');
          if (item) this.closeInner(item);
        }
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeAllInner();
        }
      });
    }
  }

  closeAllInner() {
    const openPanels = this.notificationContainer?.querySelectorAll('.js-notification-inner-content.active') || [];
    openPanels.forEach(panel => {
      panel.classList.remove('active');
      const item = panel.closest('.notification-item');
      item?.classList.remove('inner-active');
      const openBtn = item?.querySelector('.js-open-inner-content');
      openBtn?.setAttribute('aria-expanded', 'false');
    });
  }

  closeInner(item) {
    const panel = item.querySelector('.js-notification-inner-content');
    if (panel && panel.classList.contains('active')) {
      panel.classList.remove('active');
    }
    item.classList.remove('inner-active');
    const openBtn = item.querySelector('.js-open-inner-content');
    openBtn?.setAttribute('aria-expanded', 'false');
  }

  toggleNotificationContainerClass(isActive) {
    if (!this.notificationContainer) return;

    if (isActive) {
      this.notificationContainer.classList.add('display');
      this.notificationBackground.classList.add('display');
      setTimeout(() => {
        this.notificationContainer.classList.add('active');
        this.notificationBackground.classList.add('active');
      }, 50);
    } else {
      this.closeAllInner();

      this.notificationContainer.classList.add('closing');
      this.notificationBackground.classList.add('closing');
      setTimeout(() => {
        this.notificationContainer.classList.remove('active', 'closing', 'display');
        this.notificationBackground.classList.remove('active', 'closing', 'display');
      }, 300);
    }
  }
}

customElements.define('notification-hub', NotificationHub);